import { ObjectValues } from '../types';
import { VisuallyButton } from '../visually-button/visually-button.types';

export const themes = {
  default: 'default',
  error: 'error',
  success: 'success',
  warning: 'warning',
} as const;

export type Message = {
  action?: VisuallyButton;
  inline?: boolean;
  link?: {
    href: string;
    text: string;
  };
  mini?: boolean;
  text: string;
  theme?: ObjectValues<typeof themes>;
};

export const isMessageType = (
  maybeMessageType?: string,
): maybeMessageType is Message['theme'] =>
  maybeMessageType
    ? Boolean(themes[maybeMessageType as keyof Message['theme']])
    : false;

export const types: Record<string, Message['theme']> = {
  default: themes.default,
  error: themes.error,
  success: themes.success,
  warning: themes.warning,
};

export type MessageDetail = Pick<Message, 'link' | 'text' | 'theme'>;

export type Listener = (event: MessageDetail) => void;
